import { r2Fetch } from './client';

export interface R2BucketDeleteParams {
  bucket_id: string;
}

export interface R2BucketDeleteResponse {
  name: string;
  deleted_at: string;
}

export async function r2BucketDelete(
  params: R2BucketDeleteParams
): Promise<R2BucketDeleteResponse> {
  return r2Fetch<R2BucketDeleteResponse>('/rpc/r2_bucket_delete', {
    body: params,
  });
}
